import { render, staticRenderFns } from "./AcademicYearChanger.vue?vue&type=template&id=38f13486"
import script from "./AcademicYearChanger.vue?vue&type=script&lang=js"
export * from "./AcademicYearChanger.vue?vue&type=script&lang=js"
import style0 from "./AcademicYearChanger.vue?vue&type=style&index=0&id=38f13486&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38f13486')) {
      api.createRecord('38f13486', component.options)
    } else {
      api.reload('38f13486', component.options)
    }
    module.hot.accept("./AcademicYearChanger.vue?vue&type=template&id=38f13486", function () {
      api.rerender('38f13486', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/components/AcademicYearChanger.vue"
export default component.exports